import { Badge } from '@yeshuman/sdk'
import type { CallRecordExtensionProps } from '@yeshuman/sdk'
import { BookingWorkbench } from './booking-workbench'
import { CallBookingSummary } from './call-booking-summary'
import { useAppointmentContext } from '../hooks/use-call-outcomes'

export function CallBookingPanel({ record }: CallRecordExtensionProps) {
  const { data: appointmentContext } = useAppointmentContext(record.id)
  const latestBooking = appointmentContext?.latest_booking ?? null
  return (
    <>
      {latestBooking ? (
        <CallBookingSummary
          booking={latestBooking}
          patientName={appointmentContext?.patient_name}
          contactName={appointmentContext?.contact_name}
        />
      ) : null}
      <BookingWorkbench
        callRecordId={record.id}
        callerNumber={record.customer_number || ''}
        callerName={record.customer_name || ''}
        existingBooking={latestBooking}
      />
    </>
  )
}

export function CallBookedBadge({ record }: CallRecordExtensionProps) {
  const { data: appointmentContext } = useAppointmentContext(record.id)
  if (!appointmentContext?.latest_booking) return null
  return (
    <Badge variant="successSoft" className="font-normal">
      Booked
    </Badge>
  )
}
